module.exports = __webpack_public_path__ + "img/interactive-hero-slider-cjdr.2af4fb81.jpg";